class Destinations {

	constructor() {
    let queryString                 = window.location.search;
    let categoryParam               = '';
    let locationParam               = '';
    let destinations                = document.getElementById('destinations');
    let destinationFilters          = document.querySelectorAll('.destinations-filter .form-check-input');
    let destinationCategories       = [];
    let destinationLocations        = [];
    let activeDestinationCategories = [];
    let activeDestinationLocations  = [];
    let destinationTerms            = [];
    let loading                     = document.querySelector('.destinations-loading');
    let formData                    = new FormData();

    formData.set('action', 'filter_destinations');

    async function setDropdownStatus(disabled) {

      if (disabled) {

        destinationFilters.forEach(element => {
          element.parentElement.classList.add('disabled');
        });
      } else {

        if (activeDestinationCategories.length|| activeDestinationLocations.length) {
          destinationFilters.forEach(element => {
            let elementValue = parseInt(element.value);

            if (activeDestinationCategories.includes(elementValue) || activeDestinationLocations.includes(elementValue)) {
              element.parentElement.classList.remove('disabled');
            }
          });
        } else {

          destinationFilters.forEach(element => {
            element.parentElement.classList.remove('disabled');
          });
        }
      }
    }

    async function setFilter(eventTargetValue, eventTargetName, eventTargetChecked) {
      let toggle_element_id = eventTargetName.replace('[]', '').replace('_', '-') + '-toggle';

      eventTargetValue = parseInt(eventTargetValue);

      if (eventTargetName == 'destination_category[]') {
        destinationTerms = eval(destinationCategories);
      }

      if (eventTargetName == 'destination_location[]') {
        destinationTerms = eval(destinationLocations);
      }

      if (eventTargetChecked) {
        destinationTerms.push(eventTargetValue);
      } else {
        let termIndex = destinationTerms.indexOf(eventTargetValue);

        if (termIndex !== -1) {
            destinationTerms.splice(termIndex, 1);
        }
      }

      formData.set(eventTargetName, destinationTerms);
      formData.set('toggle_element_id', toggle_element_id);
    }

    async function filterDestinations() {
      fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          let toggleElement = document.getElementById(data.toggle_element_id);

          let sortedHtml = data.html.split('dest_html').sort((a, b) => {
            if (!a.length && !b.length) {
              return -1;
            }

            var first = jQuery(a).data('member');
            var second = jQuery(b).data('member');

            if(first > second) { return -1; }
            if(first < second) { return 1; }
          })

        
          destinations.innerHTML      = sortedHtml.join('');
          activeDestinationCategories = data.active_category_ids;
          activeDestinationLocations  = data.active_location_ids;
          destinationTerms            = [];

          initMap();
          setDropdownStatus();

          if (toggleElement.id == 'destination-category-toggle') {
            destinationTerms = destinationCategories;
          } else if (toggleElement.id == 'destination-location-toggle') {
            destinationTerms = destinationLocations;
          }

          if (destinationTerms.length) {
            toggleElement.querySelector('.default-toggle-label').classList.add('d-none');
            toggleElement.querySelector('.selected-toggle-label').classList.remove('d-none');

            if (destinationTerms.length > 1) {
              toggleElement.querySelector('.plural').classList.remove('d-none');
            } else {
              toggleElement.querySelector('.plural').classList.add('d-none');
            }

            toggleElement.querySelector('.selected-toggle-value').innerHTML = eval(destinationTerms).length;
          } else {
            toggleElement.querySelector('.default-toggle-label').classList.remove('d-none');
            toggleElement.querySelector('.selected-toggle-label').classList.add('d-none');
          }

          loading.classList.remove('loading');
        }).catch((error) => {
          console.error('Error:', error);
        });
    }

    if (document.body.classList.contains('page-template-page-destinations')) {

      if (sessionStorage.getItem('destination_category[]') || sessionStorage.getItem('destination_location[]')) {
        loading.classList.add('loading');

        setDropdownStatus(true);

        Object.keys(sessionStorage).forEach(function(key) {

          if (key == 'destination_category[]' || key == 'destination_location[]') {
            let value        = sessionStorage.getItem(key);
            let dropdownItem = document.querySelector('[value="' + value  + '"]');

            if (dropdownItem) {
              dropdownItem.setAttribute('checked', 'checked');
            }

            if (value && key) {
              setFilter(value, key, true);
            }
          }
        });

        filterDestinations();
      }

      sessionStorage.removeItem('destination_category[]');
      sessionStorage.removeItem('destination_location[]');

      if (queryString) {
        let urlParams = new URLSearchParams(queryString);

        loading.classList.add('loading');

        setDropdownStatus(true);

        urlParams.forEach(function(value, key) {
          let dropdownItem = document.querySelector('[value="' + value  + '"]');

          if (dropdownItem) {
            dropdownItem.setAttribute('checked', 'checked');
          }

          setFilter(value, key, true);
        });

        filterDestinations();
      }

      destinationFilters.forEach(element => {

        element.addEventListener('change', (event) => {
          let eventTargetValue = parseInt(event.target.value);
          let eventTargetName  = event.target.name;

          loading.classList.add('loading');

          setDropdownStatus(true);
          setFilter(eventTargetValue, eventTargetName, event.target.checked);
          filterDestinations();
        })
      });
    }

  }
}

export default Destinations;
